var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-4.37114e-08 1 -1 -1.05524e-06 100 0.55835)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.5583,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7497 48.23L63.505 35.3501H60.9561L51.6152 46.5328L44.157 35.3501H35.5521L46.8337 52.2618L35.5521 65.7668H38.101L47.9652 53.9575L55.8431 65.7668H64.448L52.7497 48.23ZM49.2579 52.4093L48.1142 50.7257L39.0196 37.3272H42.9358L50.2753 48.1403L51.4175 49.8239L60.9576 63.8794H57.043L49.2579 52.4093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventX);
export default __webpack_public_path__ + "static/media/canvas_event_x.a4a8ccc4c1974bfe0d90c19776ba3182.svg";
export { ForwardRef as ReactComponent };